import { createContext, useContext } from "react";
import type { Invoice } from "../types/invoice.types";

export type InvoiceOverviewContextValue = {
  invoice: Invoice | null;
  refetch: () => Promise<void>;
};

const InvoiceOverviewContext =
  createContext<InvoiceOverviewContextValue | null>(null);

export function useInvoiceOverview(): InvoiceOverviewContextValue {
  const ctx = useContext(InvoiceOverviewContext);
  if (!ctx) {
    throw new Error(
      "useInvoiceOverview must be used within InvoiceOverviewContext.Provider",
    );
  }
  return ctx;
}

export default InvoiceOverviewContext;
